import { jsx } from "react/jsx-runtime";
import PreviewIcon from "@mui/icons-material/Preview";
import { validateTidalLicense } from "../../base/index.js";
function Preview(props) {
  return /* @__PURE__ */ jsx(
    PreviewIcon,
    {
      "data-testid": "Preview",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Preview",
      "data-tidal-icon-meta": "folders,notes,lists"
    }
  );
}
Preview.tidalIconMeta = {
  categories: "folders,notes,lists",
  name: "Preview"
};
validateTidalLicense();
export {
  Preview
};
//# sourceMappingURL=Preview.js.map
